
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ScheduleItem } from '@/Model/checkout/cart/types'

@Component({})
export default class PaymentScheduleEntry extends Vue {
  @Prop({ required: true }) item!: ScheduleItem
  @Prop({ default: false }) isPayToday!: boolean
  @Prop({ default: '' }) payTodayLabel!: string

  get amountLabel(): string {
    return this.formatCurrency(this.item.amount)
  }

  get dateLabel(): string {
    return this.formatDate(this.item.date)
  }

  formatCurrency(amount: number): string {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }
}
